import React from "react";

export default function AboutUs() {
  return (
    <div className="about-page">
      <style>
        {`
          .about-page {
            background-color: white;
            color: black;
            min-height: 100vh;
            padding: 60px 200px;
            font-family: Arial, sans-serif;
            text-align: left;
          }

          .about-header {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 40px;
          }

          .about-header h1 {
            font-size: 28px;
            font-weight: bold;
            margin: 0;
            color: black;
          }

          .about-section {
            margin-bottom: 30px;
          }

          .about-section h3 {
            font-size: 20px;
            font-weight: bold;
            margin-top: 25px;
            margin-bottom: 10px;
            color: black;
          }

          .about-section p,
          .about-section li {
            font-size: 16px;
            line-height: 1.4;
            margin-top: 5px;
            margin-bottom: 10px;
            color: black;
          }

          .about-section ul {
            padding-left: 20px;
          }

          @media (max-width: 768px) {
            .about-page {
              padding: 40px 30px;
            }

            .about-header h1 {
              font-size: 22px;
            }

            .about-section p,
            .about-section li {
              font-size: 15px;
            }
          }
        `}
      </style>

      <div className="about-header">
        <h1>🧾 About Us</h1>
      </div>

      <div className="about-content">
        <div className="about-section">
          <p>
            At <strong>Partner Service</strong>, we believe in building bridges—not just between businesses, but between ideas, people, and possibilities.
          </p>

          <p>
            Founded with a vision to simplify collaboration and empower partnerships, our platform helps organizations connect, coordinate, and grow together. Whether managing logistics, sharing resources, or streamlining workflows, we provide the tools and transparency to make it seamless.
          </p>

          <p>
            We’re more than just a service—we’re a partner in your success. Our team brings expertise in technology, operations, and customer experience to deliver solutions that are reliable, scalable, and tailored to your needs.
          </p>
        </div>

        <div className="about-section">
          <h3>What We Stand For:</h3>
          <ul>
            <li>🤝 <strong>Collaboration First:</strong> Meaningful connections and shared goals.</li>
            <li>🔒 <strong>Trust & Transparency:</strong> Your data, your control—always.</li>
            <li>🚀 <strong>Innovation with Purpose:</strong> Every feature solves real-world challenges.</li>
            <li>🌍 <strong>Scalable Impact:</strong> From startups to enterprises, we grow with you.</li>
          </ul>
        </div>

        <div className="about-section">
          <p>
            Whether you're a vendor, distributor, or service provider, <strong>Partner Service</strong> is your digital ally—helping you move faster, smarter, and together.
          </p>
        </div>
      </div>
    </div>
  );
}
